<template>
  <main class="app-container p10">
    <h2>提交课程计划</h2>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <md-field title="">
          <ValidationProvider name="开始日期" rules="required" v-slot="{ errors }">
            <md-input-item
                    title="开始日期"
                    type="date"
                    placeholder=""
                    v-model="post.start_day"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>
          <ValidationProvider name="时间" rules="required" v-slot="{ errors }">
            <md-input-item
                    title="时间"
                    placeholder="例如：9点至10点"
                    v-model="post.time"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>
          <md-field-item title="课时">
            <md-stepper slot="right" v-model="post.sessions" min="1" />
          </md-field-item>

          <!--<md-field-item title="价格(元)">-->
            <!--<md-stepper slot="right" v-model="post.qty" min="1" />-->
          <!--</md-field-item>-->
          <ValidationProvider name="价格(元)" rules="required" v-slot="{ errors }">
            <md-input-item
                    title="价格(元)"
                    type="number"
                    placeholder=""
                    v-model="post.price"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>
          <ValidationProvider name="活动地点" rules="required" v-slot="{ errors }">
            <md-input-item
                    title="活动地点"
                    placeholder=""
                    v-model="post.place"
                    :error="errors[0]"
            ></md-input-item>
          </ValidationProvider>

          <md-textarea-item
                  autosize
                  v-model="post.content"
                  placeholder="备注"
          />

        </md-field>

        <div class="btn-wrap mt10">
          <md-button type="primary" native-type="submit">申请</md-button>
          <md-button type="default" class="mt10" @click="goHistory">查看申请历史</md-button>
        </div>
      </form>
    </ValidationObserver>

  </main>
</template>

<script>
import { Field, FieldItem,TextareaItem,Button,InputItem,Stepper,DatePicker } from 'mand-mobile'
import { ValidationProvider,ValidationObserver,extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', required);


export default {
  name: "CoursePlanApply",
  components: {
      [Field.name]: Field,
      [FieldItem.name]: FieldItem,
      [TextareaItem.name]: TextareaItem,
      [InputItem.name]: InputItem,
      [Button.name]: Button,
      [Stepper.name]: Stepper,
      ValidationProvider,ValidationObserver
  },
    data() {
        return {
            post:{price:"",place:"",sessions:1,content:""},
        }
    },
    methods: {
        onSubmit(e) {
            this.$toast.loading("提交中...");
            this.$http.post(`course-plans`, {...this.post})
                .then(({data}) => {
                    console.log(data);
                    this.$toast.hide();
                    this.$dialog.alert({
                        title: '申请提交成功',
                        icon: 'success',
                        content: '工作人员将尽快与你联系',
                        confirmText: '确定',
                        onConfirm: () => {
                            this.$router.back();
                        },
                    });
                })
                .catch(({response}) => {
                    console.log(response);
                })
        },
        goHistory() {
            this.$router.push("/leader/course-plans")
        }
    }
};
</script>


<style lang="scss" scoped>
h2 {
  margin: 20px 0 30px;
  font-weight:normal;
}

</style>
